import React, {useEffect, useState} from "react";
import associateServices from "../../services";
import SplideContainer from "../splide-container";
import Loading from "../loading";
import {useTranslation} from "react-i18next";
import {useInView} from "react-intersection-observer";
import StyleHelper from "../../helpers/styleHelper";
import store from "../../reducers/createReducers";
import DataActions from "../../actions/data-actions";
import {useSelector} from "react-redux";

const BuyBonusGames = () => {
    const {buyBonusGames, buyBonusGamesDone} = useSelector(state => state.dataReducer)
    const {ref, inView} = useInView({
        triggerOnce: true, // Mount the component only once
        threshold: .4, // Mount when 10% of the component is visible
    });
    const {t} = useTranslation()
    const [data, setData] = useState([])
    const [coloredData, setColoredData] = useState([])
    useEffect(() => {
        setColoredData(data?.map(oo => ({
            ...oo,
            color: oo.color === 'random' ? StyleHelper.getRandomColor() : oo.color
        })))
    }, [data])
    const [loading, setLoading] = useState(true)

    useEffect(() => {
        if (data?.length <= 0 && inView && !buyBonusGamesDone) {
            setLoading(true)
            associateServices.getDashboardSlideGames({
                type: 'bonus'
            }).then(handleResponse)
        }

    }, [inView, data, buyBonusGamesDone])

    const handleResponse = (res) => {
        store.dispatch(DataActions.setBuyBonusGames(res?.data || []))
        // setData(res?.data)
        setLoading(false)
    }

    useEffect(() => {
        setData(buyBonusGames)
    }, [buyBonusGames])

    if (!loading && data?.length <= 0)
        return null

    return (

        <div ref={ref} className="section" id="buy-bonus-games-wrapper">
            <div className="container">

                <SplideContainer
                    title={t('groups.buy-bonus-games')}
                    loading={loading}
                    data={coloredData}
                    icon={'buy-bonus'}
                    path={'/casino/group/bonus-buy'}

                />
            </div>
        </div>

    )

}

export default BuyBonusGames
/*

 */
